import type { PreviewDictionary } from './types';

export const fr: PreviewDictionary = {
    bottomTabBar: {
        home: 'Accueil',
        map: 'Carte',
        products: 'Produits',
        carwash: 'Lave-auto',
        ageGated: 'Restreint',
        more: 'Plus',
    },
    home: {
        greeting: 'Bonjour,',
        myClubs: 'Mes clubs',
        viewAll: 'Voir tout',
        coupons: 'Coupons',
        inStore: 'En magasin',
        mealDeals: 'Combos repas',
        mealDealsValidity: 'Valable du 27 mai 2025 au 10 novembre 2025',
    },
    customizePanel: {
        title: 'Personnaliser la prévisualisation',
        regionLabel: 'Région',
        regionQc: 'Québec',
        regionCa: 'Reste du Canada',
        languageLabel: 'Langue',
        reorderSections: 'Réorganiser les sections',
    },
    common: {
        languageEn: 'Anglais',
        languageFr: 'Français',
        emptyPlaceholder: 'Pas encore de contenu...',
    },
    promotion: {
        title: 'Promotion',
        use: 'Utiliser',
        upcoming: 'À venir',
        expired: 'Expiré',
        validBetweenStart: 'Valide entre le ',
        validBetweenJoin: ' et le ',
        timeRangeJoin: ' à ',
        validUntil: 'Valide jusqu’au :',
    },
    games: {
        header: 'Jeux & concours',
        playButton: 'Jouer',
        fromDateStart: 'Du ',
        fromDateJoin: ' au ',
    },
    promotions: {
        title: 'Promotions',
        tabCoupons: 'Coupons',
        tabInStore: 'En Magasin',
        couponsHeading: 'COUPONS',
        inStoreHeading: 'EN MAGASIN',
        offersPlaceholder: 'Offres',
        categoriesPlaceholder: 'Catégories',
    },
};
